import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import { GetMoneyValue, getThousandComma } from "../../Api/ApiCommon";
import { GetServiceSetData } from "../../Api/ServiceDatas";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import Flex from "../../components/DefaultStyles/Flex";
import DropDown, { OptionType } from "../../components/Filters/DropDown";
import Search from "../../components/Filters/Search";
import { PartyInfoFilterContainer } from "../../components/pages/Party/PartyInfo/PartyInfoFilter";
import LineBtn from "../../components/Button/LineBtn";
import ConfirmBtn from "../../components/Button/ConfirmBtn";
import CouponPointRegisterModal from "../../components/pages/Benefit/Coupon/CouponPointRegisterModal";
import { toast } from "react-toastify";
import Loader from "../../components/DefaultStyles/Loader";
import { authType } from "../Login";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import { TotalCount } from "../Users/UserInfo";
import FilterIcon from "../../components/DefaultStyles/FilterIcon";
import LingoKidsUpdateModal from "../../components/pages/Party/LingokidsInfo/LingoKidsUpdateModal";

interface ILingokidsCoupon {
  id: string;
  partyid: number;
  code: string;
  state: number;

  regdate: string;

  updatedate?: string;
}

export const getStateStr = (state: number) => {
  switch (state) {
    case 0:
      return "할당 전";
      break;
    case 1:
      return "할당 함";
      break;
    case 2:
      return "정상 사용";
      break;
    case 3:
      return "기사용(타계정)";
      break;
    case 4:
      return "만료 코드";
      break;
    case 5:
      return "무효 코드";
      break;
    case 6:
      return "기사용(자계정)";
      break;

    default:
      break;
  }
};

export const lingokidsPageState = atom<number>({
  key: "lingokidsPageState",
  default: 0,
});

export default function Lingokids() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();
  const [savedPage, setSavedPage] = useRecoilState<number>(lingokidsPageState);

  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(page);
  }, [page]);
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [useDropdownValue, setUseDropdownValue] = useState<OptionType>({
    value: "1",
    label: "사용",
  });
  const [updateModal, setUpdateModal] = useState<{
    visible: boolean;
    data: ILingokidsCoupon;
  }>({
    visible: false,
    data: {} as ILingokidsCoupon,
  });
  const [couponToastModal, setCouponToastModal] = useState(false);
  const [filteringValue, setFilteringValue] = useState({
    isUse: 1,
  });

  const { response, fetchData, loading } = useApi({
    method: "get",
    url:
      `party/ringcode?page=${page}&size=10` +
      (searchValue !== "" ? `&${dropDownValue?.value}=${searchValue}` : ``) +
      `&state=${filteringValue?.isUse}`,
  });

  const tableHead = [
    "ID",
    "Code",
    "상태",
    "등록 일시",
    "업데이트 일시",
    "PID",
    "수정/등록",
  ];

  const options: OptionType[] = [{ value: "code", label: "쿠폰 코드" }];

  const useOptions: OptionType[] = [
    { value: "1", label: "사용" },
    { value: "0", label: "미사용" },
  ];

  // useEffect(() => {
  //   if (couponToastModal) {
  //     fetchData({
  //       method: "get",
  //       url:
  //         `party/ringcode?page=${page}&size=10` +
  //         (searchValue !== ""
  //           ? `&${dropDownValue?.value}=${searchValue}`
  //           : ``) +
  //         `&state=${filteringValue?.isUse}`,
  //     });

  //     toast.success("쿠폰 지급이 완료되었습니다.", {
  //       onClose: () => setCouponToastModal(false),
  //     });
  //   }
  // }, [couponToastModal]);

  // useEffect(() => {}, [useDropdownValue, filteringValue]);

  return (
    <>
      <PageTitle title="링고키즈 쿠폰" />

      <ManageFilterContainer>
        <Flex gapSize={10}>
          <DropDown
            isDisabled={false}
            setDropDownValue={setDropDownValue}
            dropdownValue={dropDownValue}
            optionList={options}
            boxWidth={180}
          />

          <Search
            placeholder="입력"
            setSearchValue={setSearchValue}
            isDisabled={dropDownValue ? false : true}
            pageResetEvent={() => setPage(0)}
            inputType={
              dropDownValue?.value === "phone" || dropDownValue?.value === "uid"
                ? "number"
                : undefined
            }
          />
        </Flex>

        <Flex gapSize={40}>
          <Flex gapSize={10}>
            <FilterIcon maxWidth={1350} />

            {/* 사용 여부 */}
            <DropDown
              isDisabled={false}
              setDropDownValue={setUseDropdownValue}
              dropdownValue={useDropdownValue}
              optionList={useOptions}
              boxWidth={120}
            />

            <ConfirmBtn
              btnText="적용"
              btnColor="mint"
              btnHeight={38}
              btnClickEvent={() => {
                setPage(0);
                setFilteringValue({
                  isUse: Number(useDropdownValue?.value) ?? 1,
                });
              }}
              isDisabled={useDropdownValue?.value === ""}
            />

            <LineBtn
              btnText="초기화"
              icon="refresh"
              btnHeight={38}
              btnColor="mint"
              btnClickEvent={() => {
                setUseDropdownValue({
                  value: "1",
                  label: "사용",
                });
                setFilteringValue({
                  isUse: 1,
                });
              }}
              disabled={useDropdownValue?.value === ""}
            />
          </Flex>
        </Flex>
      </ManageFilterContainer>

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={879}>
          <>
            {response?.data?.items?.map((d: ILingokidsCoupon) => {
              return (
                <TableBody key={d?.id}>
                  <TableBodyItem>{d?.id}</TableBodyItem>
                  <TableBodyItem>{d?.code}</TableBodyItem>
                  <TableBodyItem>{getStateStr(d?.state)}</TableBodyItem>

                  <TableBodyItem>
                    {d?.regdate
                      ? dayjs(d?.regdate)?.format("YYYY-MM-DD HH:mm")
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.updatedate
                      ? dayjs(d?.updatedate)?.format("YYYY-MM-DD HH:mm")
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={d?.partyid === 0 ? false : true}
                    onClick={() => {
                      if (d?.partyid !== 0) {
                        setSavedPage(page);
                        navigate(`/party/info/${d?.partyid}`);
                      }
                    }}
                  >
                    {d?.partyid === 0 ? "-" : d?.partyid}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="수정/등록"
                      btnClickEvent={() =>
                        setUpdateModal({
                          visible: true,
                          data: d,
                        })
                      }
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload
        tableHead={tableHead.concat(["aa"])}
        pushedData={(e: any) => {
          return [
            e.id,
            e.code,
            e.state,
            e?.regdate ? dayjs(e?.regdate)?.format("YYYY-MM-DD HH:mm") : "-",
            e?.updatedate
              ? dayjs(e?.updatedate)?.format("YYYY-MM-DD HH:mm")
              : "-",
            e?.partyid === 0 ? "-" : e?.partyid,
          ];
        }}
        dataUrl={
          `party/ringcode?page=0&size=1000` +
          (searchValue !== ""
            ? `&${dropDownValue?.value}=${searchValue}`
            : ``) +
          `&state=${filteringValue?.isUse}`
        }
        disabled={response?.data?.items?.length < 1}
        title="링고키즈 쿠폰 관리"
      />

      {/* 쿠폰/포인트 지급 모달 */}
      {updateModal.visible && (
        <LingoKidsUpdateModal
          closeEvent={() =>
            setUpdateModal({ visible: false, data: {} as ILingokidsCoupon })
          }
          confirmEvent={() => {
            setUpdateModal({ visible: false, data: {} as ILingokidsCoupon });
            fetchData({
              method: "get",
              url:
                `party/ringcode?page=${page}&size=10` +
                (searchValue !== ""
                  ? `&${dropDownValue?.value}=${searchValue}`
                  : ``) +
                `&state=${filteringValue?.isUse}`,
            });
          }}
          id={updateModal?.data?.id}
          code={updateModal?.data?.code}
          partyid={updateModal?.data?.partyid}
          state={updateModal?.data?.state}
        />
      )}

      {loading && <Loader />}
    </>
  );
}

const ManageFilterContainer = styled(PartyInfoFilterContainer)`
  @media screen and (max-width: 1350px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
